import {IconProp} from "@fortawesome/fontawesome-svg-core"
import MenuItems from "./menuItems"

interface ListProps {
    icon: IconProp
    selected_icon: IconProp
    name: string
    child: any
    open: boolean
    path: string
    active: boolean
    isHover: boolean
}

const MenuListItems = ({icon, selected_icon, name, child, open, path, active, isHover}: ListProps) => {
    return (
        <MenuItems
            selected_icon={selected_icon}
            icon={icon}
            name={name}
            child={child}
            open={open}
            isHover={isHover}
            path={path}
            active={active}
        />
    )
}
export default MenuListItems
